/** Post shape from `content/posts` consumed by list components. */
export interface Article {
  _path: string
  title: string
  date: string
  description: string
  cover?: string
  tags?: string[]
  badges?: { bg: string, text: string, content: string, color?: string }[]
}

/** Narrow Content `queryContent().find()` results for templates. */
export function toArticles(docs: object[] | null | undefined): Article[] {
  return (docs ?? []) as unknown as Article[]
}
